import noop from 'lib/function/noop'
import { createContext } from 'react'

type ClickHandler = (id: string) => void

// OfferListImpressionTrackerContext provides an interface to track clicks
// on offers in an offer list (or anything that has an ID).
const ClickTrackerContext = createContext<ClickHandler>(noop)

export default ClickTrackerContext
